import Duck from 'extensible-duck';
import Immutable from 'immutable';

const $$reports = Immutable.fromJS([
  {
    id: 0,
    value: 'SSN Validation',
    tooltip:
      'Checkr queries the SSN provided by the applicant against information provided by the Social Security Administration (SSA) to determine whether the SSN is associated with a number on the SSA’s Death Master File. If the number listed on the Death Master File, the Checkr system prompts the applicant to provide additional information.',
  },
  {
    id: 1,
    value: 'Address History',
    tooltip:
      'The SSN Trace includes a compilation of addresses associated with the SSN. Based on this information and your package scope, Checkr will use address history to determine which jurisdictions to search for court records.',
  },
  {
    id: 2,
    value: 'Sex Offender Check',
    tooltip:
      'A thorough background check should include a Sex Offender Registry Check. Checkr searches registries for every state. The data returned includes date of registration and current status.',
  },
  {
    id: 3,
    value: 'Global Watchlist Search',
    tooltip:
      'This check searches known domestic and international terrorist watchlists as well as the records of the Office of Inspector General (OIG), Excluded Parties List (EPL) and additional domestic and international agency lists.',
  },
  {
    id: 4,
    value: 'National Criminal Search',
    tooltip:
      'This check searches millions of national records. It reveals summary case information, but does not provide details.',
  },
  {
    id: 5,
    value: 'Current County Search',
    bold: true,
    tooltip:
      'Performs direct searches of county court records. This search is part of the baseline for establishing due diligence. Results include felony and misdemeanor criminal cases as well as, charges, disposition, dates and sentencing information.',
  },
  {
    id: 6,
    value: 'Motor Vehicle Record',
    bold: true,
    tooltip:
      'Offers a full Driving Records Check that provides records from all 50 states plus the District of Columbia. Reports detail: license status, violations and infractions, accidents, suspensions or revocations, expiration date, and endorsements.',
  },
]);

export default new Duck({
  namespace: 'organizers',
  store: 'checkr',
  types: [],
  initialState: Immutable.fromJS({
    $$packages: [
      {
        id: 'basic',
        attributes: {
          // checkrId: '4d270313cffad6747e564d34',
          name: 'Basic',
          slug: 'basic',
          passThroughFees: false,
          priceCents: 2999,
          description: 'A basic background check',
          reports: $$reports.filter($$report =>
            [0, 1, 2, 3, 4].includes($$report.get('id'))
          ),
        },
      },
      {
        id: 'standard_driver',
        attributes: {
          // checkrId: '4d270313cffad6747e564d34',
          name: 'Standard Driver',
          slug: 'standard_driver',
          passThroughFees: true,
          priceCents: 4949,
          description: 'A more comprehensive background check',
          reports: $$reports.filter($$report =>
            [0, 1, 2, 3, 4, 5, 6].includes($$report.get('id'))
          ),
        },
      },
    ],
    isLoading: true,
    isSubmitting: false,
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({}),
});
